import React, { PropTypes, Component } from 'react'
import PlayButton from './PlayButton'
import NextButton from './NextButton'
import PreviousButton from './PreviousButton'
import styled from 'styled-components'
import constants from '../constants'

const PlayerWrapper = styled.div`
  position: relative;
  z-index: 50;
  display: flex;
  text-align: left;
  @media (max-width: 767px) {
    max-width: calc(50% - 30px);
    flex-direction: column;
  }
`
const PlayerTitle = styled.span`
  margin-left: 10px;
  align-self: center;
  display: block;
  @media (max-width: 767px) {
    align-self: flex-start;
    order: -1;
    margin-left: 0;
    margin-bottom: 10px;
  }
  animation: fade-in 0.3s;
`

const Controls = styled.div`
  > * {
    cursor: pointer;
    padding: 0;
    background: none;
    color: #fff;
    vertical-align: middle;
    border: none;
    width: 30px;
    height: 30px;
    outline: none;
    border-radius: 100px;
    text-align: center;
    transition: box-shadow 0.3s;
    &:focus {
      box-shadow: 0 0 0px 1px rgba(255, 255, 255, 0.5);
    }
    &:hover {
      box-shadow: 0 0 0 1px #fff;
    }
    > img {
      display: block;
    }
    + * {
      margin-left: 10px;
    }
  }
`

class Player extends Component {
  constructor () {
    super()
    this.state = {autoplayed: false}
    this.handlePlay = this.handlePlay.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrevious = this.handlePrevious.bind(this)
  }
  componentWillReceiveProps (props) {
    if (!props.playing && props.autoplay && !this.state.autoplayed) {
      this.setState({autoplayed: true, playing: true}, () => {
        props.soundCloudAudio.play()
      })
    } else if (props.playing !== this.props.playing) {
      // Keep the play/pause icon in sync with the widget's actual state (e.g.
      // a track finishing, or auto_play kicking in after a load).
      this.setState({playing: props.playing})
    }
  }
  handlePlay () {
    let { playing, soundCloudAudio } = this.props
    if (!playing) {
      if (soundCloudAudio) soundCloudAudio.play()
      this.setState({playing: true})
    } else {
      if (soundCloudAudio) soundCloudAudio.pause()
      this.setState({playing: false})
    }
  }
  handleNext () {
    let {day, songs, playSong, soundCloudAudio} = this.props
    let index = songs.indexOf(day)
    let song = index >= songs.length - 1 ? songs[0] : songs[index + 1]
    this.setState({playing: true})
    playSong(song, soundCloudAudio)
  }
  handlePrevious () {
    let {day, songs, playSong, soundCloudAudio} = this.props
    let index = songs.indexOf(day)
    let song = index <= 0 ? songs[songs.length - 1] : songs[index - 1]
    this.setState({playing: true})
    playSong(song, soundCloudAudio)
  }
  render () {
    let { active, animating, day, controls } = this.props
    return (
      <PlayerWrapper>
        <Controls>
          {controls && <PreviousButton handlePrevious={this.handlePrevious} {...this.props} />}
          <PlayButton handlePlay={this.handlePlay} {...this.props} playing={this.state.playing} />
          {controls && <NextButton handleNext={this.handleNext} {...this.props} />}
        </Controls>
        {day && ((!animating && active === constants.SHOW_OVERLAY) || controls) &&
          <PlayerTitle active={active} animating={animating} className='Text'>
            {day.title}
          </PlayerTitle>}
      </PlayerWrapper>
    )
  }
}

Player.propTypes = {
  playing: PropTypes.bool,
  track: PropTypes.object,
  soundCloudAudio: PropTypes.object,
  active: PropTypes.string,
  animating: PropTypes.bool,
  controls: PropTypes.bool,
  songs: PropTypes.array,
  day: PropTypes.object,
  autoplay: PropTypes.bool,
  playSong: PropTypes.func
}

export default Player



/** WEBPACK FOOTER **
 ** ./src/components/Player.js
 **/